import { useCallback } from 'react';
import {
  endTransaction,
  getTransactionContext,
  initSession,
  startTransaction,
} from '../transaction';

export const useTransaction = () => {
  const startTx = useCallback((name?: string) => {
    const id = startTransaction();
    return id;
  }, []);

  const endTx = useCallback(() => {
    endTransaction();
  }, []);

  const withTransaction = useCallback(
    async <T>(name: string, fn: () => Promise<T>): Promise<T> => {
      startTx(name);
      try {
        return await fn();
      } finally {
        endTx();
      }
    },
    [startTx, endTx],
  );

  return {
    initSession,
    startTransaction: startTx,
    endTransaction: endTx,
    withTransaction,
    getTransactionContext,
  };
};
